import I18n from "i18n-js";
import Constants from "common/constant";

export const ParentWarningTitle = () => (
  <>
    <div className="flex-row-center">
      <div className="flex-col-view">
        <p className="text-body text-2xl leading-[37px] text-textcolor-black text-center whitespace-pre">
          {I18n.t("MSG_PARENT_GATE_WARNING")}
        </p>
      </div>
      <img
        alt="*"
        src={`${Constants.assetHost}/assets/images/duck_attention.png`}
        className="w-[208px] h-[240px] pointer-events-auto"
      />
    </div>

    <div className="flex-col-center w-[568px] h-[58px] bg-white border-[#B7714D] mb-[20px] border-y-[4px]">
      <p className="text-body text-3xl leading-[42px] text-textcolor-black text-center whitespace-pre">
        {I18n.t("MSG_PARENT_GATE_TITLE")}
      </p>
    </div>
  </>
);
